// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */", "",{"version":3,"sources":["/home/runner/work/zippelin-admin/zippelin-admin/src/styles.scss"],"names":[],"mappings":"AAAA,8EAAA","file":"styles.scss","sourcesContent":["/* You can add global styles to this file, and also import other style files */"]}]);
// Exports
module.exports = exports;
